<template>
  <transition name="fade" mode="out-in">
    <div class="sbar-item" :class="{ active: isActive() }" @click="goTo">
      <i class="sbar-item-icon bi" :class="props.icon"></i>
      <div class="sbar-item-title">{{ props.label }}</div>
      <div v-if="props.count !== undefined" class="sbar-item-count">{{ props.count }}</div>
    </div>
  </transition>
</template>

<script setup lang="ts">
const appStore = useAppStore();
const route = useRoute();
const router = useRouter();

const props = defineProps<{
  routeName: string,
  section?: 'Overview' | 'Tracking' | 'Results',
  icon: string,
  label: string,
  count?: number,
  active?: boolean, // overrides the route based active state
}>();

function isActive() {
  if (props.active !== undefined) return props.active;
  if (props.section && props.section === appStore.currentCampaignTab && route.name === props.routeName) return true;
  else if (!props.section && route.name === props.routeName) return true;
  return false;
}

function goTo() {
  if (!props.section) router.push({ name: props.routeName });
  else {
    if (route.name !== props.routeName) router.push({ name: props.routeName });
    appStore.changeTab(props.section);
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.sbar-item {
  display: flex;
  align-items: center;
  height: 26px;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;

  overflow: visible;
  white-space: nowrap;

  
  
  &.active {
    background-color: var(--primary-100-color);
    border: 1px solid $primary-color;

    // &::before {
    //   content: "";
    //   position: block;
    //   height: 16px;
    //   width: 4px;
    //   border-radius: 4px;
    //   background-color: var(--primary-color);
    // }
  }

  &:hover {
    background-color: var(--primary-300-color);
    color: $black-color;
  }

  .sbar-item-title {
    font-size: 14px;
    font-weight: 500;
  }

  .sbar-item-icon {
    font-size: 16px;
  }

  .sbar-item-count {
    margin-left: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: var(--light-grey-color);
    font-size: 12px;
    font-weight: 600;
    line-height: 20px;
    text-align: center;
  }
}
</style>